import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Product } from '../../../../resources/product';
import { Subject } from 'rxjs';
import { OrderDetailService, fetchLatest } from '../../order-detail.service';
import { UpdateChange } from '@cots/common/autosaving/change';
import { ProductDiffReviewItem } from '@cots/order/resources/product-diff';

@Component({
  selector: 'estimating-planning-changes-review',
  templateUrl: './estimating-planning-changes-review.component.html',
  styleUrls: ['./estimating-planning-changes-review.component.less']
})
export class EstimatingPlanningChangesReviewComponent implements OnInit, OnChanges {

  @Input() editing = false;
  @Input() product: Product;
  @Output() changed = new EventEmitter<void>();
  
  constructor(private service: OrderDetailService) { }

  private dirty = false;
  public internalState: ProductDiffReviewItem[];
  private updateSubject = new Subject<void>();

  private async init(productId: string) {
    const product = await fetchLatest(this.service.getProductObservable(productId));
    this.dirty = false;
    this.internalState = product.previousPlanningChanges ?? [];
  }
  

  ngOnInit(): void {
    this.init(this.product.productId);
    this.updateSubject.subscribe(() => {
      this.flushInternalState(this.product.productId);
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.product && changes.product.previousValue && changes.product.previousValue.productId !== changes.product.currentValue?.productId) {
      if (changes.product.previousValue) await this.flushInternalState(changes.product.previousValue.productId);
      this.internalState = null;
      this.init(this.product.productId);
    }
  }

    private async flushInternalState(productId: string) {
    if (!this.dirty || !this.internalState) return;
    const product = await fetchLatest(this.service.getProductObservable(productId));
    const change: UpdateChange = {
      changeType: 'UPDATE',
      entity: 'Product',
      data: {
        itemId: product.productId,
        field: 'previousPlanningChanges',
        oldValue: product.previousPlanningChanges,
        newValue: this.internalState,
      },
    };
    this.service.recordChanges(change);
    this.dirty = false;
  }
  
  public update(itemIndex: number, value: boolean) {
    this.dirty = true;
    this.internalState[itemIndex].checked = value;
    this.updateSubject.next();
  }
  
  

}
